export default __webpack_public_path__ + "static/media/About_IMG-Diligence.a93a52c0.png";